export default "__VITE_ASSET__af040f83__"